
const ourServicesList = [
  {
    title: 'Understand the market',
    shortDescription: 'Get a holistic view of the healthcare and pharma market through our insightful ',
    link: '/consulting/market-assessment-services',
    imageSrc: 'img/home/png/understand-the-market.png',
    altText: 'Get a holistic view of the healthcare and pharma market through our insightful ',
    buttonTitle: 'Know More',
  },
  {
    title: 'Estimate the forecast',
    shortDescription: 'Be the leader in the pharma market with the help of our 10-year market and epidemiology forecast',
    link: '/report-store.php?category=Market Insight',
    imageSrc: 'img/home/png/estimate-the-forecast.png',
    altText: 'Be the leader in the pharma market with the help of our 10-year market and epidemiology forecast',
    buttonTitle: 'Know More',
  },
  {
    title: 'Analyze the pipeline',
    shortDescription: 'Gain rich knowledge of the upcoming therapies for better business-related decisions',
    link: '/report-store.php?category=Pipeline Insight',
    imageSrc: 'img/home/png/analyse-the-pipeline.png',
    altText: 'Gain rich knowledge of the upcoming therapies for better business-related decisions',
    buttonTitle: 'Know More',
  },
  {
    title: 'Monitor the competitors',
    shortDescription: 'Know and inspect your competitors to stand out in the industry',
    link: '/consulting/competitive-intelligence-services',
    imageSrc: 'img/home/png/monitor-the-competitors.png',
    altText: 'Know and inspect your competitors to stand out in the industry',
    buttonTitle: 'Know More',
  },
  {
    title: 'Streamline your journey',
    shortDescription: 'Consulting services that help in meeting desired goals through optimized strategy',
    link: '/consulting/asset-prioritizaton-services',
    imageSrc: 'img/home/png/streamline-your-journey.png',
    altText: 'Consulting services that help in meeting desired goals through optimized strategy',
    buttonTitle: 'Know More',
  },
  {
    title: 'Accelerate your growth',
    shortDescription: 'Exploit innovative ideas through our in-depth and curated R&D services',
    link: '/consulting/business-development-services',
    imageSrc: 'img/home/png/accelerate-your-growth.png',
    altText: 'Exploit innovative ideas through our in-depth and curated R&D services',
    buttonTitle: 'Know More',
  }
];
const accordionList = [
  {
    title: 'Customizable Reports',
    content: 'Customized reports specific to geographies, clinical trials, epidemiological trends, and markets.',
    link: '/report-store.php',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Solutions',
    content: 'Identify your needs, and our analysts will provide granular-level market intelligence to fulfill them.',
    link: '/request-for-proposal',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Competitive Intelligence',
    content: 'Custom-based analysis of the competitors to meet your unique needs.',
    link: '/consulting/competitive-intelligence-services',
    buttonTitle: 'Know More',
  },
  {
    title: 'Customizable Packages',
    content: 'Hassle-free subscription-based report packages the way you desire through our PharmDelve.',
    link: '/pharmdelve',
    buttonTitle: 'Know More',
  },
];
const counterList = [
  {
    title: 'Reports',
    imageSrc: 'img/home/svg/research_reports.svg',
    altText: 'Reports',
    numbers: '7000',
  },
  {
    title: 'Consulting Projects',
    imageSrc: 'img/home/svg/consulting_projects.svg',
    altText: 'Consulting Projects',
    numbers: '500',
  },
  {
    title: 'Satisfied Clients',
    imageSrc: 'img/home/svg/satisfied_clients.svg',
    altText: 'Satisfied Clients',
    numbers: '1000',
  },
  {
    title: 'Customized Reports',
    imageSrc: 'img/home/svg/customized_reports.svg',
    altText: 'Customized Reports',
    numbers: '1200',
  },
];
const blogList = [
  {
    title: "Redefining Liver Disease in the Metabolic Era: From NASH to MASH and the Rise of Obesity‐targeted Therapies",
    shortDescription: "The paradigm shift from Non‐alcoholic Steatohepatitis (NASH) to Metabolic Dysfunction–associated Steatohepatitis (MASH) reflects a deeper understanding of the pathophysiology underpinning liver injury in the context of obesity, diabetes, and metabolic syndrome.",
    link: "/blog/emerging-obesity-targeted-therapies-for-mash",
    imageSrc: "img/home/png/redefining-liver-disease-in-the-metabolic-era-from-NASH-to MASH-and-the-rise-of-obesity-targeted-therapies.png",
    altText: "Redefining Liver Disease in the Metabolic Era: From NASH to MASH and the Rise of Obesity‐targeted Therapies",
  },
  {
    title: "Prader-Willi Syndrome Drug Market Heats Up: 5 Upcoming Challengers to Soleno’s VYKAT XR",
    shortDescription: "Since the FDA approved recombinant human growth hormone (rhGH) for Prader-Willi syndrome in 2000, numerous companies have faced challenges in developing more advanced treatments for hyperphagia, the uncontrollable hunger associated with PWS.",
    link: "/blog/prader-willi-syndrome-drugs",
    imageSrc: "img/home/png/prader-willi-syndrome-drug-market-heats-up-5-upcoming-challengers-to-solenos-VYKAT-XR.png",
    altText: "Prader-Willi Syndrome Drug Market Heats Up: 5 Upcoming Challengers to Soleno’s VYKAT XR",
  },
  {
    title: "Sanofi’s Qfitlia Enters the Hemophilia Market—What Sets It Apart?",
    shortDescription: "Over the past three years, the FDA has approved six new hemophilia treatments, including three gene therapies. Now, Sanofi’s Qfitlia (fitusiran) enters the competitive hemophilia therapeutics market, distinguishing itself as the only therapy approved for all types of hemophilia.",
    link: "/blog/qfitlia-for-hemophilia-treatment",
    imageSrc: "img/home/png/sanofis-qfitlia-enters-the-hemophilia-market-what-sets-It-apart.png",
    altText: "Sanofi’s Qfitlia Enters the Hemophilia Market—What Sets It Apart?",
  },
  {
    title: "Revolutionary Advances and Bright New Horizons in Multiple Myeloma Treatment",
    shortDescription: "Multiple myeloma, a complex blood cancer rooted in the bone marrow, affects 160K people globally each year, with a mortality rate of 106K. According to DelveInsight, nearly 75K new cases were reported across seven major markets in 2023, a figure expected to climb in the coming years.",
    link: "/blog/latest-breakthroughs-multiple-myeloma-treatment",
    imageSrc: "img/home/png/revolutionary-advances-and-bright-new-horizons-in-multiple-myeloma-treatment.png",
    altText: "Revolutionary Advances and Bright New Horizons in Multiple Myeloma Treatment",
  },
  {
    title: "Mucopolysaccharidosis Type I Treatment Pipeline — 4 Promising Therapies on the Way",
    shortDescription: "Affecting around 1 in 200 people, Graves’ disease is the most common cause of an overactive thyroid. More than 12% of the US population will develop a thyroid condition during their lifetime and an estimated 20 million Americans have some form of thyroid disease.",
    link: "/blog/mps-i-treatment-pipeline",
    imageSrc: "img/home/png/mucopolysaccharidosis-type-I-treatment-pipeline-4-promising-therapies-on-the-way.png",
    altText: "Mucopolysaccharidosis Type I Treatment Pipeline — 4 Promising Therapies on the Way",
  },
  {
    title: "8 Emerging Bispecific Antibodies Transforming NSCLC Treatment",
    shortDescription: "MPS I treatment typically involves Hematopoietic Stem Cell Transplantation (HSCT), Enzyme Replacement Therapy (ERT), or a combination of both, along with supportive care such as pain management, anti-inflammatory medications, oxygen therapy, and surgery.",
    link: "/blog/bispecific-antibodies-for-nsclc",
    imageSrc: "img/home/png/8-emerging-bispecific-antibodies-transforming-NSCLC-treatment.png",
    altText: "8 Emerging Bispecific Antibodies Transforming NSCLC Treatment",
  },
];
const reportList = {
  content: [
    {
      title: 'Latest Reports',
      description: 'Get comprehensive insights into the healthcare industry and epidemiology-based market forecasts with a 360° panoramic picture of the market alongside the latest trends, developments, and future opportunities.',
      shortTitle: 'Report Store',
      shortDescription: 'With over 7000 research reports in the repository covering 27 therapeutic areas, stay updated about the most recent trends, news, and developments in the healthcare domain.',
      buttonTitle: 'Explore Now',
    },
  ],
  items: [
    {
      link: '/report-store/epilepsy-market',
      imageSrc: 'products/report-image/epilepsy-market-reports.png',
      altText: 'Epilepsy Market Insight, Epidemiology and Market Forecast -2034',
    },
    {
      link: '/report-store/intratumoral-cancer-therapies-market',
      imageSrc: 'products/report-image/intratumoral-cancer-therapies-market-report.png',
      altText: 'Intra-tumoral Cancer Therapies – Market Insights, Epidemiology, and Market Forecast – 2034',
    },
    {
      link: '/report-store/iga-nephropathy-igan-market',
      imageSrc: 'products/report-image/iga-nephropathy-igan-market.png',
      altText: 'IgA Nephropathy (IgAN) - Market Insight, Epidemiology And Market Forecast - 2034',
    },
    {
      link: '/report-store/her2-low-cancers-market-forecast',
      imageSrc: 'products/report-image/her2-low-cancers-market.png',
      altText: 'HER2-low Cancers – Market Size, Target Population, Competitive Landscape, and Market Forecast–2034',
    },
    {
      link: '/report-store/peanut-allergy-market',
      imageSrc: 'products/report-image/peanut-allergy-market.png',
      altText: 'Peanut Allergy Market Insight, Epidemiology And Market Forecast - 2034',
    },
  ],
};
export {
  ourServicesList,
  accordionList,
  counterList,
  blogList,
  reportList,
}